var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 171,
    viewBox: "0 0 174 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.52 89.2598C133.52 114.255 113.255 134.52 88.2598 134.52C63.2642 134.52 43 114.255 43 89.2598C43 64.2628 63.2642 44 88.2598 44C113.257 44 133.52 64.2628 133.52 89.2598Z",
    fill: "#65AFE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.52 89.2598C133.52 114.255 113.255 134.52 88.2598 134.52C63.2642 134.52 43 114.255 43 89.2598C43 64.2628 63.2642 44 88.2598 44C113.257 44 133.52 64.2628 133.52 89.2598Z",
    fill: "url(#paint0_linear_solar_sun)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9961 36.175L88.0292 0L90.0623 36.175H85.9961Z",
    fill: "#FFD046"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.795 37.3338L76.4805 23.8557L80.7985 36.6293L76.795 37.3338Z",
    fill: "#FFD046"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9356 40.0702L57.457 5.38208L71.7569 38.6805L67.9356 40.0702Z",
    fill: "#FFD046"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6871 44.3037L54.7734 31.7456L63.2078 42.2735L59.6871 44.3037Z",
    fill: "#FFD046"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.297 49.8993L30.5703 20.8823L55.4114 47.2896L52.297 49.8993Z",
    fill: "#FFD046"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9954 56.6936L37.0781 46.5701L48.6101 53.5836L45.9954 56.6936Z",
    fill: "#FFD046"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9704 64.4753L10.6172 44.6299L43.0035 60.9595L40.9704 64.4753Z",
    fill: "#FFD046"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3778 73.012L25.5312 66.546L38.7694 69.1974L37.3778 73.012Z",
    fill: "#FFD046"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3197 82.0413L0 73.759L36.0267 78.0419L35.3197 82.0413Z",
    fill: "#FFD046"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8676 91.291L21.5195 89.2607L34.8676 87.2305V91.291Z",
    fill: "#FFD046"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0253 100.478L0 104.759L35.3197 96.4797L36.0253 100.478Z",
    fill: "#FFD046"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.768 109.324L25.5312 111.974L37.3764 105.508L38.768 109.324Z",
    fill: "#FFD046"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0035 117.561L10.6172 133.89L40.9704 114.045L43.0035 117.561Z",
    fill: "#FFD046"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6126 124.938L37.082 131.95L45.9979 121.828L48.6126 124.938Z",
    fill: "#FFD046"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4128 131.23L30.5703 157.636L52.2984 128.621L55.4128 131.23Z",
    fill: "#FFD046"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2064 136.25L54.7734 146.775L59.6857 134.219L63.2064 136.25Z",
    fill: "#FFD046"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7544 139.839L57.4531 173.136L67.9331 138.449L71.7544 139.839Z",
    fill: "#FFD046"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7985 141.892L76.4805 154.664L76.795 141.188L80.7985 141.892Z",
    fill: "#FFD046"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0623 142.346L88.0278 178.52L85.9961 142.346H90.0623Z",
    fill: "#FFD046"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2561 141.188L99.5747 154.664L95.2539 141.894L99.2561 141.188Z",
    fill: "#FFD046"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.117 138.449L118.597 173.136L104.297 139.837L108.117 138.449Z",
    fill: "#FFD046"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.364 134.219L121.278 146.775L112.844 136.251L116.364 134.219Z",
    fill: "#FFD046"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M123.758 128.621L145.483 157.636L120.641 131.23L123.758 128.621Z",
    fill: "#FFD046"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M130.055 121.828L138.971 131.949L127.441 124.941L130.055 121.828Z",
    fill: "#FFD046"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M135.08 114.045L165.433 133.89L133.047 117.561L135.08 114.045Z",
    fill: "#FFD046"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M138.674 105.511L150.52 111.973L137.285 109.327L138.674 105.511Z",
    fill: "#FFD046"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M140.73 96.4783L176.051 104.761L140.023 100.476L140.73 96.4783Z",
    fill: "#FFD046"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M141.184 87.2319L154.532 89.2594L141.186 91.2924L141.184 87.2319Z",
    fill: "#FFD046"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M140.023 78.0425L176.051 73.761L140.73 82.0404L140.023 78.0425Z",
    fill: "#FFD046"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.285 69.1974L150.52 66.546L138.674 73.0134L137.285 69.1974Z",
    fill: "#FFD046"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M133.047 60.9596L165.436 44.6313L135.08 64.4754L133.047 60.9596Z",
    fill: "#FFD046"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M127.441 53.5836L138.971 46.5701L130.055 56.6936L127.441 53.5836Z",
    fill: "#FFD046"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M120.641 47.2897L145.485 20.8838L123.755 49.8994L120.641 47.2897Z",
    fill: "#FFD046"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M112.848 42.2735L121.279 31.7456L116.368 44.3037L112.848 42.2735Z",
    fill: "#FFD046"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M104.293 38.6825L118.597 5.38403L108.116 40.0707L104.293 38.6825Z",
    fill: "#FFD046"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2539 36.6293L99.5734 23.8557L99.2589 37.3338L95.2539 36.6293Z",
    fill: "#FFD046"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_solar_sun",
    x1: 88.2598,
    y1: 44,
    x2: 88.2598,
    y2: 134.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarSun);
export default __webpack_public_path__ + "static/media/solar-sun.0814ec43fadb6280743f8b213e2828b9.svg";
export { ForwardRef as ReactComponent };